import { profile } from "console";

export const environment = {
    api: 'https://app-gsenvio-test-bmgzb8fqewcmaper.westeurope-01.azurewebsites.net',
    token: 'token-api',
    urlimages: 'http://localhost:4200/images',
    urlicon: 'http://localhost:4200/icons',
    profile:'profile',
};
